<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <validation-observer ref="employeesForm">
        <b-form class="auth-login-form" @submit.prevent="onFormSubmit">
          <div class="model_events">
            <b-row>
              
              <b-col cols="12">
                <div class="d-flex align-items-center justify-content-between">
                  <h3>المعلومات الشخصية</h3>
                  <b-link @click="$router.go(-1)">
                    رجوع <feather-icon icon="ArrowLeftIcon" />
                  </b-link>
                </div>
                <hr />
              </b-col>
              <b-col cols="3">
                <form-input
                  rules="required"
                  id="first_name"
                  label="الاسم الأول*"
                  v-model="form.first_name"
                />
              </b-col>

              <b-col cols="3">
                <form-input
                  rules="required"
                  id="last_name"
                  label="الكنية*"
                  v-model="form.last_name"
                />
              </b-col>
              <b-col cols="3">
                <form-input
                  rules="required"
                  id="father_name"
                  label="اسم الأب*"
                  v-model="form.father_name"
                />
              </b-col>
              <b-col cols="3">
                <form-input
                  rules="required"
                  id="mother_name"
                  label="اسم الأم*"
                  v-model="form.mother_name"
                />
              </b-col>
              <b-col cols="3">
                <form-mask
                  label="الرقم الوطني*"
                  id="id-num"
                  v-model="form.id_number"
                  options="blockNomber11"
                  rules="required"
                />
              </b-col>
              <b-col md="3">
                <form-mask
                  label="رقم التواصل*"
                  id="id-num"
                  v-model="form.contact_number"
                  options="blockNomber10"
                  rules="required"
                />
              </b-col>

              <b-col cols="3">
                <form-select
                  id="options_gander"
                  :options="optionsGander"
                  label="الجنس*"
                  :reduce="(x) => x.value"
                  :getOptionLabel="(x) => x.title"
                  v-model="form.gander"
                  rules="required"
                />
              </b-col>

              <b-col cols="3">
                <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  id="form_birthday"
                  v-model="form.birthday"
                  label="تاريخ الميلاد*"
                  rules="required"
                />
              </b-col>

              <b-col cols="3">
                <form-select
                  id="select_holds_disability_card_employee"
                  :options="optionsIs_holds_disability_card"
                  label="يحمل بطاقة إعاقة"
                  :reduce="(x) => x.value"
                  :getOptionLabel="(x) => x.title"
                  v-model="form.is_holds_disability_card"
                  rules="required"
                />
              </b-col>

              <b-col cols="3">
                <form-input
                  rules="required"
                  id="address"
                  label="عنوان السكن*"
                  v-model="form.address"
                />
              </b-col>
              <b-col class="mt-2" cols="12">
                <h3>المعلومات الوظيفية</h3>
                <hr />
              </b-col>

              <b-col cols="3">
                <form-select
                  label="الفرع*"
                  v-model="form.branch_id"
                  :getOptionLabel="(x) => x.governorate_name"
                  :reduce="(x) => x.id"
                  id="branch_id_"
                  ep="v2/selects/branches"
                  rules="required"
                />
              </b-col>

              <b-col cols="3">
                <form-input
                  rules="required"
                  id="position"
                  label="المنصب الوظيفي*"
                  v-model="form.position"
                />
              </b-col>
              <b-col cols="3">
                <form-input
                  rules="required"
                  id="work"
                  label="العمل*"
                  v-model="form.work"
                />
              </b-col>
              <b-col cols="3" v-if="!isVolunteer">
                <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  id="employment_date"
                  v-model="form.employment_date"
                  label="تاريخ بداية التوظيف*"
                  rules="required"
                />
              </b-col>
              <b-col cols="3" v-if="isVolunteer">
                <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  id="employment_date"
                  v-model="form.employment_date"
                  label="تاريخ بداية التطوع*"
                  rules="required"
                />
              </b-col>
              <b-col cols="3" v-if="!isVolunteer">
                <form-mask
                  options="date"
                  placeholder="YYYY-MM-DD"
                  id="form_resignation"
                  v-model="form.resignation_date"
                  label="تاريخ الاستقالة"
                />
              </b-col>

              <b-col cols="3" v-if="!isVolunteer">
                <form-mask
                  id="insurance_number"
                  options="blockNomberIndeterminate"
                  label="رقم التأمينات"
                  v-model="form.insurance_number"
                />
              </b-col>
              <b-col cols="3" v-if="!isVolunteer">
                <form-mask
                  id="number_employee"
                  options="blockNomberIndeterminate"
                  label="رقم التوظيف ضمن المنظمة"
                  v-model="form.code"
                />
              </b-col>
              <b-col cols="3">
                <form-select
                  label="المؤهلات العلمية *"
                  ep="v2/selects/qualifications"
                  v-model="form.qualification_id"
                  id="qualification"
                  :reduce="(x) => x.id"
                  :getOptionLabel="(x) => x.title"
                  rules="required"
                />
              </b-col>
              <b-col cols="3">
                <form-select
                  id="member_status"
                  :options="optionSmember_status"
                  label="حالة العضو*"
                  :reduce="(x) => x.value"
                  :getOptionLabel="(x) => x.title"
                  v-model="form.member_status"
                  rules="required"
                />
              </b-col>
            </b-row>
          </div>

          <div class="d-flex justify-content-end">
            <b-button variant="success" type="submit">
              <feather-icon class="mr-25" icon="EditIcon" />
              حفظ
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-card>
</template>

<script>
import "quill/dist/quill.snow.css";
import FormMask from "@/components/form-mask";
import { quillEditor } from "vue-quill-editor";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BButton,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormTimepicker,
  BForm,
  BCol,
  BCard,
  BLink,
} from "bootstrap-vue";
import FormSelect from "@/components/form-select/index.vue";
import FormInput from "@/components/form-input/index.vue";
import FormDatepicker from "@/components/form-datepicker/index.vue";
import { mapActions, mapGetters } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
export default {
  props: ["id"],
  components: {
    FormDatepicker,
    FormMask,
    quillEditor,
    BRow,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormTimepicker,
    FormSelect,
    BForm,
    BCol,
    BCard,
    BLink,
    FormInput,
    ValidationObserver,
    LoadingOverlay,
  },
  data: () => ({
    rouls: null,
    form: {},
    optionsIs_holds_disability_card: [
      { value: 1, title: "نعم" },
      { value: 0, title: "لا" },
    ],
    optionsGander: [
      { value: 1, title: "ذكر" },
      { value: 0, title: "أنثى" },
    ],
    optionSmember_status: [
      { value: 1, title: "نشط" },
      { value: 0, title: "غير نشط" },
    ],
  }),

  methods: {
    ...mapActions("AdministrativeStatus/Employees", [
      "getEmployeeById",
      "addEmployee",
      "updateEmployee",
    ]),

    onFormSubmit() {
      this.$refs.employeesForm.validate().then(async (success) => {
        if (success) {
          if (this.isAdd)
            this.addEmployee({ type: this.type, data: this.form }).then(() => {
              this.$router.push({ name: this.type });
            });
          else
            this.updateEmployee({
              id: this.id,
              type: this.type,
              data: this.form,
            }).then(() => {
              this.$router.push({ name: this.type });
            });
        }
      });
    },
  },

  computed: {
    ...mapGetters("AdministrativeStatus/Employees", ["loading"]),
    isAdd() {
      return this.id === "new";
    },
    isVolunteer() {
      return this.$route.path.includes("volunteer");
    },
    type() {
      return this.isVolunteer ? "volunteers" : "employees";
    },
  },

  created() {
    if (!this.isAdd)
      this.getEmployeeById({
        id: this.id,
        type: this.isVolunteer ? "volunteers" : "employees",
      }).then((empData) => {
        var initForm = { ...empData };
        initForm.qualification_id = initForm.qualification
          ? initForm.qualification.id
          : null;
        initForm.branch_id = initForm.branch ? initForm.branch.id : null;
        delete initForm.branch;
        delete initForm.qualification;
        if (initForm.resignation_date === null)
          delete initForm.resignation_date;
        this.form = { ...initForm };
      });
  },
};
</script>
